import { Badge } from "@bcc/components/ui/badge";
import { useOptionalTour } from "@bcc/contexts/tour-context";
import { useTranslation } from "react-i18next";
import { setTourTestId } from "../tour.utils";

/** Marks a table as sample data while the tour shows demo rows; renders nothing in normal use */
export function DemoDataTag() {
  const { t } = useTranslation();
  const isDemoDataActive = useOptionalTour()?.isDemoDataActive ?? false;
  if (!isDemoDataActive) return null;

  return (
    <Badge variant="secondary" testId={setTourTestId("demo-data-tag")}>
      {t("tour.demoData.tag")}
    </Badge>
  );
}
